// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instruction {
  margin: 20px auto;
  font-family: Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}
.instruction h2 {
  color: #444;
  font-size: 20px;
  margin-bottom: 10px;
}
.instruction p {
  margin-bottom: 10px;
}
.instruction strong {
  color: #007bff;
}
.instruction ul {
  margin: 10px 0;
  padding-left: 20px;
}
.instruction ul li {
  margin-bottom: 5px;
}
.instruction .highlight {
  color: #d9534f;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/instruction_page/Instruction.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AACJ;AALA;EAOM,WAAA;EACA,eAAA;EACA,mBAAA;AACN;AAVA;EAaM,mBAAA;AAAN;AAbA;EAiBM,cAAA;AADN;AAhBA;EAqBM,cAAA;EACA,kBAAA;AAFN;AApBA;EAyBQ,kBAAA;AAFR;AAvBA;EA8BM,cAAA;EACA,iBAAA;AAJN","sourcesContent":[".instruction {\n    margin: 20px auto;\n    font-family: Arial, sans-serif;\n    color: #333;\n    line-height: 1.6;\n    \n    h2 {\n      color: #444;\n      font-size: 20px;\n      margin-bottom: 10px;\n    }\n  \n    p {\n      margin-bottom: 10px;\n    }\n  \n    strong {\n      color: #007bff;\n    }\n  \n    ul {\n      margin: 10px 0;\n      padding-left: 20px;\n  \n      li {\n        margin-bottom: 5px;\n      }\n    }\n  \n    .highlight {\n      color: #d9534f;\n      font-weight: bold;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
